var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _c("Grid", {
        attrs: {
          module: _vm.module,
          data: _vm.classes,
          columns: _vm.columnOptions,
          onRequest: _vm.fetchStudentClasses,
          onLaunch: _vm.select
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue: props.value == "SCHEDULED",
                      green:
                        props.value == "ACTIVE" ||
                        props.value == "APPROVED" ||
                        props.value == "COMPLETED",
                      purple: props.value == "PROCESSED",
                      red: props.value == "CANCELLED",
                      yellow: props.value == "HELD"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.value) + "\n      ")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }